<template>
  <div class="con-present">
    <section class="con-present-relate display-pc" v-if="lectures.length">
      <div class="container">
        <ul class="columns is-multiline">
          <li class="column is-one-third" v-for="(lecture, index) in lectures" :key="index">
            <div class="present">
              <router-link :to="'/presentation/' + lecture.id" :class="lecture.speakerIds.length>2?'multi':''">
                <div class="title">{{lecture.title}}</div>
                <div class="relative-bottom" :class="lecture.speakerIds.length>1?'multi':''">
                  <div class="bottom" v-for="(sid, idx) in lecture.speakerIds" :key="idx" v-if="speakers[sid]">
                    <img :src="speakers[sid].avatar+'?imageView2/0/w/800'">
                    <div class="detail">
                      <h4>{{speakers[sid].name}}</h4>
                      <h6>{{speakers[sid].company}}</h6>
                      <h6 class="position">{{speakers[sid].position}}</h6>
                    </div>
                  </div>
                </div>
              </router-link>
              <div class="down">
                <router-link :to="{path: '/search', query: {id: tags[tid].tag_id}}" v-for="(tid, idx) in lecture.tag_ids" class="l-tag" :key="idx" v-html="tags[tid].name"></router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['lectures'],
  computed: {
    ...mapState(['speakers', 'tags'])
  }
}
</script>

<style lang="sass" scoped>

.con-present > .title
  // background-color: #2180c2
  // background-color: var(--primary-color)
  height: 45px
  line-height: 45px
  font-size: 18px
  color: #fff
  text-align: center

.column
  width: 31.2%

.con-present-relate
  // background-color: #f5f7f8
  h2
    font-size: 24px
    color: #3e3a39
    text-align: center
    margin-bottom: 30px
  .present
    display: block
    // height: 100%
    border: 1px solid #d6dce3
    padding: 20px 15px
    background-color: #fff
    transition: all 0.25s
    &.multi
      height: auto
    &:hover
      box-shadow: 0 0 10px rgba(192, 209, 226, .8)
    a
      .title
        display: block
        font-size: 18px
        color: var(--primary-color)
        margin-bottom: 15px
        height: 54px
    .down
      font-size: 14px
      margin-top: 15px
      .l-tag
        font-size: 12px
        color: #ababab
        padding: 2px 15px
        border: 1px solid #ababab
        border-radius: 15px
        margin-right: 10px
        transition: all 0.3s linear
      .l-tag:hover
        color: var(--primary-color)
        border-color: var(--primary-color)
    .relative-bottom
      &.multi
        .bottom
          margin-top: 10px
          &:first-child
            margin-top: 0
          img
            width: 50px
            height: 50px
          .detail
            h6
              display: inline-block
              margin-top: 5px
      .bottom
        display: flex
        align-items: center
        img
          width: 95px
          height: 95px
          border-radius: 50%
          border: 1px solid #f2f2f2
        .detail
          flex-grow: 1
          margin-left: 15px
          h4
            font-size: 18px
            color: var(--primary-color)
          h6
            font-size: 14px
            color: #8e9ca9
            margin-top: 9px
            line-height: 1.4em
          .position
            margin-top: 3px

</style>
